interface Props {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onPerPageChange?: (perPage: number) => void;
  /** Short label for screen readers */
  itemLabel?: string;
}

/** Prev/next + page numbers + optional rows-per-page (for list views with server-side pagination). */
export default function PaginationBar({
  page,
  perPage,
  total,
  onPageChange,
  onPerPageChange,
  itemLabel = "items",
}: Props) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const from = total === 0 ? 0 : (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);

  return (
    <div className="pagination-bar">
      <p className="pagination-summary" aria-live="polite">
        {total === 0 ? (
          <>Geen resultaten</>
        ) : (
          <>
            <strong>{from}</strong>–<strong>{to}</strong> van <strong>{total}</strong> {itemLabel}
          </>
        )}
      </p>
      <div className="pagination-controls">
        {onPerPageChange && (
          <label className="pagination-per">
            <span className="pagination-per-label">Per pagina</span>
            <select
              className="filter-select"
              value={perPage}
              onChange={(e) => onPerPageChange(Number(e.target.value))}
            >
              {[10, 25, 50, 100].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        )}
        <div className="pagination-nav">
          <button
            type="button"
            className="btn-secondary pagination-btn"
            disabled={page <= 1}
            onClick={() => onPageChange(1)}
            title="Eerste pagina"
          >
            «
          </button>
          <button
            type="button"
            className="btn-secondary pagination-btn"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            Vorige
          </button>
          <span className="pagination-page-indicator">
            Pagina {page} / {totalPages}
          </span>
          <button
            type="button"
            className="btn-secondary pagination-btn"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Volgende
          </button>
          <button
            type="button"
            className="btn-secondary pagination-btn"
            disabled={page >= totalPages}
            onClick={() => onPageChange(totalPages)}
            title="Laatste pagina"
          >
            »
          </button>
        </div>
      </div>
    </div>
  );
}
